import { render } from "./NotificacionConfig.vue?vue&type=template&id=8b3ebb4c&scoped=true"
import script from "./NotificacionConfig.vue?vue&type=script&lang=js"
export * from "./NotificacionConfig.vue?vue&type=script&lang=js"

import "./NotificacionConfig.vue?vue&type=style&index=0&id=8b3ebb4c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3ebb4c"]])

export default __exports__